import React, { FC } from 'react'
import { IconButton, IconButtonProps } from '@mui/material'

const EvtIconButton: FC<IconButtonProps> = ({ children, ...props }) => {
    return <IconButton {...props}>{children}</IconButton>
}

export default EvtIconButton
